module.exports = __webpack_public_path__ + "static/media/l12_voice_seven_v2.a158b1f6.mp3";